"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.page-title {\n  text-align: right; }\n  .page-title * {\n    margin-bottom: 16px; }\n\n.page-title-container {\n  width: 260px;\n  padding-right: 16px;\n  padding-top: 3px; }\n\n@media (max-width: 66rem) {\n  .page-title {\n    text-align: left;\n    width: 100%; }\n  .page-title-container {\n    padding-left: 16px; } }\n";
  const fileName = "PageTitle_PageTitle";
  const element = document.querySelector("style[data-sass-component='PageTitle_PageTitle']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const PageTitle = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "page-title-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "page-title"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "sia-text-08"
  }, children)));
};
var _default = exports.default = PageTitle;